import React from 'react';
import { Container, Row, Col, Image, Card,Button } from 'react-bootstrap';
import aluMainImage from '../Assets/Image/copper1.jpg';
import alu1 from '../Assets/Images/alu-busbar-1.jpg';
import alu2 from '../Assets/Images/Range6.webp';
import alu3 from '../Assets/Images/alu-busbar-3.jpg';
import alu4 from '../Assets/Images/product20.jpg';
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";

const FabricatedAluminumBusbars = () => {
    const navigate = useNavigate();

  const relatedProducts = [
    { name: "Drilled Aluminum Busbar", image: alu1 },
    { name: "Bended Aluminum Busbar", image: alu2 },
    { name: "Silver Plated Aluminum Busbar", image: alu3 },
    { name: "Custom Fabricated Busbar", image: alu4 },
  ];

  return (
    <>
      <section className="productbanner1 d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">
          <Row className="justify-content-center">
            <Col lg={8} className="hero-content text-center">
              <h2
                className="hero-title"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
               <span className="blue-text">Fabricated Aluminum </span>{" "}
            <span className="white-text">Busbars</span>
              </h2>
              <p
                className="hero-subtitle"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
               Lightweight yet durable busbars designed for high current distribution with exceptional conductivity and corrosion resistance.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <div className="fabricated-aluminum-section py-3 bg-light"style={{ position: "relative" }}>
        <Button
          onClick={() => navigate("/ourproducts")}
          className="back-btn"
        >
          <IoMdArrowRoundBack className="back-icon" />
          Back
        </Button>
        <Container>
          <Row className="text-center mb-4">
            <Col>
              <h3 className="fw-bold section-title">Fabricated Aluminum Busbars <span className="title-underline"></span></h3>
              <p className="text-muted mb-4">
                Engineered for electrical panels, switchgears, and power distribution systems, our aluminum busbars are precision-crafted for maximum performance and design flexibility.
              </p>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md={4}>
             <Image 
  src={aluMainImage} 
  fluid 
  rounded 
  alt="Fabricated Aluminum Busbar"
  height={500}
  width={400}
/>

            </Col>
            <Col md={8}>
              <h5 className="fw-semibold">Key Features:</h5>
              <ul className="text-muted ps-3">
                <li>High electrical conductivity with reduced weight</li>
                <li>Anti-oxidation and corrosion-resistant surface</li>
                <li>Precision fabrication for customized applications</li>
                <li>Environmentally friendly and recyclable material</li>
                <li>Cost-effective solution vs copper</li>
              </ul>

              <h5 className="fw-semibold mt-4">Finish & Coatings:</h5>
              <ul className="text-muted ps-3">
                <li>Plain (mill finish)</li>
                <li>Silver Plated</li>
                <li>Tin Plated</li>
                <li>Anodized Aluminum (on request)</li>
              </ul>
            </Col>
          </Row>

          <h4 className="fw-bold mt-5 mb-4 text-center">Related Products</h4>
          <Row className="g-4 mb-4">
            {relatedProducts.map((product, index) => (
              <Col key={index} xs={12} sm={6} md={3}>
                <Card className="h-100 text-center shadow-sm border-0">
                  <Card.Img
                    variant="top"
                    src={product.image}
                    alt={product.name}
                    style={{ height: '180px', objectFit: 'contain', padding: '10px' }}
                  />
                  <Card.Body>
                    <Card.Title className="text-muted fs-6">{product.name}</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <h5 className="fw-semibold">Applications:</h5>
          <ul className="text-muted ps-3">
            <li>Low and medium voltage panels</li>
            <li>Control panels and switchboards</li>
            <li>Battery interconnections and EV systems</li>
            <li>Renewable energy systems (solar & wind)</li>
            <li>Transformer connections</li>
          </ul>

          <h5 className="fw-semibold mt-4">Specifications:</h5>
          <ul className="text-muted ps-3">
            <li>Material: EC Grade Aluminum / 6101 / 6063 / 1050</li>
            <li>Thickness: 3mm to 25mm</li>
            <li>Width: 10mm to 300mm</li>
            <li>Custom hole, slots, and threading as per drawing</li>
            <li>Conductivity: Up to 62% IACS</li>
          </ul>

          <h5 className="fw-semibold mt-4">Customization:</h5>
          <p className="text-muted">
            We fabricate aluminum busbars as per your exact drawings or samples. Services include bending, punching, threading, tapping, plating, and anodizing. Let us deliver your busbars pre-finished and installation-ready.
          </p>

          <p className="text-muted">
            All materials are tested for dimensional accuracy, conductivity, and corrosion resistance before dispatch.
          </p>
        </Container>
      </div>
    </>
  );
};

export default FabricatedAluminumBusbars;
